import React, { useState } from 'react';
import axios from '../api/axiosInstance';
import useAuthStore from '../store/useAuthStore';
import { FaPencilAlt, FaCheck } from 'react-icons/fa';
import SERVER_URL from "../config/server";
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const ProfilePage = () => {
  const { username, email, bio, title, ProfilePicture, checkAuth } = useAuthStore();
  const [isEditing, setIsEditing] = useState(false);
  const [updatedBio, setUpdatedBio] = useState('');
  const [updatedUsername, setUpdatedUsername] = useState(username);
  const [updatedTitle, setUpdatedTitle] = useState(title);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const token = Cookies.get('token');

  const profileImage = SERVER_URL + ProfilePicture;

  const handleSave = async () => {
    try {
      const response = await axios.put('/user/profile', {
        username: updatedUsername,
        bio: updatedBio,
        title: updatedTitle,
        token
      }, { withCredentials: true });

      if (response.status === 200) {
        const { token } = response.data;
        Cookies.set("token", token, { expires: 7 });
        setMessage('Profile updated successfully!');
        checkAuth(); // Refresh Zustand store
        setIsEditing(false);
      } else {
        setMessage('Failed to update profile.');
      }
    } catch (error) {
      console.error(error);
      setMessage('An error occurred.');
    }
  };

  const handleEditProfilePicture = () => {
    navigate('/uploadavatar'); // Redirect to upload page
  };

  return (
    <div className="min-h-screen flex mt-10 items-center justify-center bg-gray-900 text-white p-4">
      <div className="bg-gray-800 p-4 sm:p-8 rounded-2xl shadow-lg w-full max-w-md">
        
        {/* Profile Picture with Editable Icon */}
        <div className="relative flex justify-center mb-6">
          <div className="relative w-28 h-28">
            <img
              src={profileImage}
              alt="Avatar"
              className="w-full h-full rounded-full border-2 border-slate-700 object-cover"
            />
            <button
              onClick={handleEditProfilePicture}
              className="absolute bottom-0 right-0 bg-blue-600 p-2.5 rounded-full hover:bg-blue-700 shadow-md flex items-center justify-center transition-all"
              title="Edit Profile Picture"
            >
              <FaPencilAlt size={12} color="#fff" />
            </button>
          </div>
        </div>

        {/* Username and Edit */}
        <div className="flex justify-between items-center mb-4">
          {isEditing ? (
            <input
              type="text"
              value={updatedUsername}
              onChange={(e) => setUpdatedUsername(e.target.value)}
              className="w-full p-2 rounded bg-gray-700 text-white"
            />
          ) : (
            <h2 className="text-2xl font-bold">{username}</h2>
          )}
          <button onClick={() => setIsEditing(!isEditing)}>
            {isEditing ? <FaCheck size={20} /> : <FaPencilAlt size={20} />}
          </button>
        </div>

        {/* Email */}
        <div className="mb-4">
          <label className="block text-gray-400 mb-1">Email</label>
          <input
            type="text"
            value={email}
            readOnly
            className="w-full p-2 rounded bg-gray-700 text-gray-300 cursor-not-allowed"
          />
        </div>

        {/* Title */}
        <div className="mb-4">
          <label className="block text-gray-400 mb-1">Title</label>
          {isEditing ? (
            <input
              type="text"
              value={updatedTitle}
              onChange={(e) => setUpdatedTitle(e.target.value)}
              className="w-full p-2 rounded bg-gray-700 text-white"
            />
          ) : (
            <p>{title}</p>
          )}
        </div>

        {/* Bio */}
        <div className="mb-4">
          <label className="block text-gray-400 mb-1">Bio</label>
          {isEditing ? (
            <textarea
              value={updatedBio}
              onChange={(e) => setUpdatedBio(e.target.value)}
              className="w-full p-2 rounded bg-gray-700 text-white"
            />
          ) : (
            <p>{bio || 'No bio added yet.'}</p>
          )}
        </div>

        {isEditing && (
          <button
            onClick={handleSave}
            className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded w-full"
          >
            Save
          </button>
        )}

        {message && <p className="mt-4 text-green-400">{message}</p>}
      </div>
    </div>
  );
};

export default ProfilePage;
